<script>
export default {
    name: 'MessageContentPayload',
    props: {
        content: {
            type: Object
        },
        time: {
            type: String
        }
    }
}
</script>

<template>
  <div class="d-flex flex-column">
    <div class="msg">[{{content.text.split("#")[2]}}]</div>
    <span class="chat-time">{{time | formatTimeHM}}</span>
  </div>
</template>

<style scoped lang="scss">
.msg {
  padding: 10px;
  background-color: white;
  border: 1px solid #EDEDED;
  border-radius: 6px;
}
.chat-time {
  color: #7B7B7B;
  font-size: 12px;
}
</style>
